import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/pro-solid-svg-icons';

import classNames from 'classnames';
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  addBottomBuffer?: string,
  className?: string,
  inline?: boolean,
  loadingText?: string,
  size?: SizeProp,
  skipTopBuffer?: boolean
}

export default function LoadingSpinner({
  addBottomBuffer,
  className,
  inline,
  loadingText,
  size = '3x',
  skipTopBuffer
}: Props) {
  const spinnerClassNames = classNames(className, {
    'd-inline': inline,
    'text-center': true,
    'top-buffer': !skipTopBuffer,
    'mb-5': addBottomBuffer
  });

  return (
    <div className={spinnerClassNames}>
      <FontAwesomeIcon
        className="text-muted"
        fixedWidth
        icon={faSyncAlt}
        size={size}
        spin
      />
      {loadingText && (
        <div className="mt-2 text-muted">
          {loadingText}
        </div>
      )}
    </div>
  );
}
